import { useEffect, useState, type FormEvent } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { toast } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { CircleSpinner } from "../../components/Loaders";
import CustomModal from "../../components/customModal";
import { getVirtualKeyboardTargetProps } from "../../helpers/virtualKeyboard";
import { sendAxiosRequestWithRetry } from "../../services/sendAxiosRequestWithRetry";
import type { AppDispatch, RootState } from "../../store";
import { toogleGetEmailPromptModal } from "../../store/slices/transactionsSlice";
import { getApiErrorText } from "../../shared/api/errors";

const EMAIL_PATTERN = /\S+@\S+\.\S+/;


const CheckoutEmailPromptModal = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch<AppDispatch>();

    const showModal = useSelector((state: RootState) => state.transactions.showEmailPromptModal);
    const showKeyboard = useSelector((state: RootState) => state.appGeneral.showKeyboard);
    const targetCheckoutDetails = useSelector((state: RootState) => state.transactions.targetCheckoutDetails);
    const targetCheckoutId = targetCheckoutDetails?.checkout_id;
    const emailKeyboardProps = getVirtualKeyboardTargetProps("email", showKeyboard);

    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState("");
    // const [sendEmailBtnHref, setSendEmailBtnHref] = useState("");
    const [showLoaderForSendingEmail, setShowLoaderForSendingEmail] = useState(false);

    useEffect(() => {
        if (showModal) {
            setEmailError("");
        }
    }, [showModal]);

    // const validateEmailAddress = () => {
    //     if (!email || !EMAIL_PATTERN.test(email)) {
    //         setEmailError(t("enterValidEmailErr"));
    //         return false;
    //     }
    //     else {
    //         setEmailError("");
    //         return true;
    //     }
    // };

    const handleChangeEmailInputValue = (event: FormEvent<HTMLInputElement>) => {
        setEmail(event.currentTarget.value);
        setEmailError("");

        // const inpVal = e.target.value;
        // setEmail(inpVal);

        // const isValid = validateEmailAddress();

        // if (isValid) {
        //     setSendEmailBtnHref(`mailto:${inpVal}`);
        // }
    };

    const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (!email || !EMAIL_PATTERN.test(email)) {
            setEmailError(String(t("enterValidEmailErr")));
            return;
        }

        setShowLoaderForSendingEmail(true);

        const {
            data: respData,
            error: respError,
        } = await sendAxiosRequestWithRetry<CashBoxApiDataFor<"/order/send_checkout_email">>({
            method: "post",
            url: "/order/send_checkout_email",
            data: {
                checkout_id: targetCheckoutId,
                email,
            },
        });

        if (respData) {
            toast.success(
                t("transactionHasBeenSentToYourEmail"),
                {
                    duration: 4000,
                }
            );
        }
        else if (respError) {
            // showErrorToast({
            //     message: getApiErrorText(respError),
            //     status: respError.statusCode,
            // });

            toast.error(
                <div>
                    <h6 className="text-capitalize">
                        {t("sendingEmailFailed")}
                    </h6>
                    <div>{getApiErrorText(respError)}</div>
                </div>,
                {
                    duration: 8000,
                }
            );
        }

        setShowLoaderForSendingEmail(false);
        dispatch(toogleGetEmailPromptModal({
            showModal: false,
        }));
    };

    const handleCloseModal = () => {
        dispatch(toogleGetEmailPromptModal({
            showModal: false,
        }));
    };


    return (
        <CustomModal
            size="sm"
            show={showModal}
            onHide={handleCloseModal}
            centered
            className="custom-prompt-modal"
        >
            <Modal.Body>
                <div className="px-3">
                    <form onSubmit={handleSubmit}>
                        <div className="modal-title mt-2 mb-3 fs-5">
                            {t("getEmailLabel")}
                        </div>
                        <div className="my-4">
                            <input
                                {...emailKeyboardProps}
                                type="text"
                                className="form-control"
                                placeholder={String(t("receiverEmailPlaceholder"))}
                                value={email}
                                onInput={handleChangeEmailInputValue}
                            />
                            {emailError && (
                                <p>
                                    <small className="text-red">
                                        <em>
                                            {emailError}
                                        </em>
                                    </small>
                                </p>
                            )}
                        </div>
                        <div className="mt-3 mb-1 text-end">
                            {/* <a
                                href={sendEmailBtnHref}
                                className={`btn btn-dark ${(!email || emailError) ? 'disabled' : ''}`}
                            >
                                {t("sendEmail")}
                            </a> */}
                            <button
                                type="submit"
                                className={`btn btn-dark ${(!email || emailError) ? "disabled" : ""}`}
                            >
                                {showLoaderForSendingEmail && (
                                    <span className="icon me-2">
                                        <CircleSpinner
                                            spinnerColor="#fff"
                                            circleOpacity={0}
                                            thickness={5}
                                        />
                                    </span>
                                )}
                                {t("sendEmail")}
                            </button>
                        </div>
                    </form>
                </div>
            </Modal.Body>
        </CustomModal>
    );
};

export default CheckoutEmailPromptModal;
